import React from 'react';
import { ASubheader } from '../../atoms/ASubheader';
import { MButton } from '../../molecules/MButton';
import { MButtonIcon, MButtonIconState } from '../../molecules/MButtonIcon';
import { isFlagTrue } from '../../utils/aemFlagUtils';
import { DEFAULT_CLOSE_BANNER_TEXT } from '../../utils/i18nConstants';
import * as Styled from './OMessageSitewide.styles';
import { OMessageSitewideProps, OMessageSitewideVariant } from './OMessageSitewide.types';

const COMPONENT_NAME = 'o-mi-web-ui-kit-OMessageSitewide';
const TEST_ID = 'mi-web-ui-kit-OMessageSitewide';

export const OMessageSitewide: React.FC<OMessageSitewideProps> = ({
  onDismiss,
  drawerState = OMessageSitewideVariant.Dismissable,
  subheader = true,
  cta = true,
  aSubheader,
  mButton,
  mButtonIcon,
  className,
}) => {
  const isDismissable = drawerState === OMessageSitewideVariant.Dismissable;
  const shouldShowDismissButton = Boolean(isDismissable && mButtonIcon && onDismiss);
  
  const shouldShowMessage = isFlagTrue(subheader);
  const shouldShowCta = isFlagTrue(cta);

  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      className={className}
    >
      <Styled.ContentWrapper>
        {shouldShowMessage && aSubheader && (
          <Styled.TextWrapper>
            <ASubheader {...aSubheader} />
          </Styled.TextWrapper>
        )}

        {shouldShowCta && mButton && <MButton {...mButton} />}
      </Styled.ContentWrapper>

      {shouldShowDismissButton && mButtonIcon?.aIcon && (
        <Styled.DismissWrapper>
          <MButtonIcon 
            {...mButtonIcon}
            state={MButtonIconState.Transparent} 
            aIcon={mButtonIcon.aIcon}
            onClick={onDismiss}
            aria-label={mButtonIcon['aria-label'] || DEFAULT_CLOSE_BANNER_TEXT}
          />
        </Styled.DismissWrapper>
      )}
    </Styled.Wrapper>
  );
};
